module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30692",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5052",
      "atom": "static-1.5414",
      "client-types": "static-1.498",
      "conversations-error-reporting": "static-1.9224",
      "conversations-internal-pub-sub": "static-1.16322",
      "conversations-internal-schema": "static-1.13435",
      "conversations-message-history": "static-1.13597",
      "conversations-test-sdk": "static-1.10834",
      "conversations-visitor-experience-components": "static-1.24055",
      "data-fetching-client": "static-1.9985",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5922",
      "hs-test-utils": "static-1.8359",
      "hubspot-dlb": "static-2.1882",
      "HubStyleTokens": "static-2.11817",
      "I18n": "static-7.1678",
      "immer": "static-1.101",
      "jasmine-immutable": "static-1.3350",
      "jasmine-runner": "static-1.6780",
      "quartz": "static-1.7490",
      "react-dlb": "static-1.89",
      "react-select-plus": "static-1.113",
      "react-transition-group": "static-2.73",
      "redux-thunk": "static-2.80",
      "reselect": "static-3.12",
      "sanitize": "static-1.4801",
      "StyleGuideUI": "static-3.505",
      "transmute": "static-2.97",
      "urlinator": "static-1.4862",
      "usage-tracker": "static-1.7642",
      "usage-tracker-core": "static-1.7492",
      "usage-tracker-public": "static-1.7453",
      "viral-links-lib": "static-1.7406",
      "visitor-ui-component-library": "static-1.6480",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5141",
      "conversations-prop-types": "static-1.7789",
      "conversations-visitor-message-history": "static-1.22792",
      "cssUtils": "static-1.950",
      "enviro": "static-4.455",
      "flux-actions": "static-1.371",
      "foundations-components": "static-1.8528",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6543",
      "interactive-cards": "static-1.395",
      "hubspot-url-utils": "static-1.4297",
      "immutable": "static-2.83",
      "metrics-js": "static-1.9867",
      "PatternValidationJS": "static-1.3222",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.958",
      "raven": "static-3.5925",
      "react": "static-7.196",
      "react-aria": "static-1.72",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "react-rhumb": "static-1.17050",
      "react-utils": "static-2.5575",
      "redux": "static-4.76",
      "rpc-client-utils": "static-1.4996",
      "redux-toolkit": "static-1.78",
      "sanitize-text": "static-1.8487",
      "signup-constants": "static-1.19669",
      "styled-components": "static-2.95",
      "usage-tracker-multi": "static-1.6056",
      "visitor-ui-component-library-icons": "static-1.6291",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1268",
      "quartz-core": "static-1.6709",
      "foundations-assets": "static-1.5212",
      "foundations-theming": "static-1.4805",
      "UIComponents": "static-3.8763",
      "conversations-async-data": "static-2.8000",
      "customer-data-email": "static-1.18557",
      "cv-backend-services": "static-1.1597",
      "immutable-less": "static-1.4978",
      "conversations-skeleton-state": "static-1.7576",
      "crm-events-viz-core": "static-1.34119",
      "customer-data-objects": "static-1.8024",
      "icons": "static-2.688",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.884",
      "ui-images": "static-2.1256",
      "apollo-stack-hubspot": "static-3.94",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.89",
      "HeadJS": "static-2.800",
      "framer-motion": "static-1.79",
      "hs-test-utils-bend-plugin": "static-1.3470",
      "msw": "static-1.39",
      "testing-library": "static-1.158",
      "i18n-data": "static-1.230",
      "moment-timezone": "static-5.91",
      "jasmine": "static-4.4641",
      "signup-ui-url-generator": "static-2.8390",
      "HubStyle": "static-2.12124",
      "quartz-i18n": "static-1.1165",
      "sassPrefix": "static-1.218",
      "bend-plugin-foundations-components": "static-1.4797",
      "floating-ui": "static-1.63",
      "foundations-theming-specialty": "static-1.2521",
      "hs-story-utils": "static-1.9754",
      "react-create-root-preference": "static-1.75",
      "react-virtualized": "static-2.107",
      "tanstack-table": "static-1.61",
      "trellis-assets": "static-1.2706",
      "ui-fonts": "static-1.1079",
      "hs-locale-management": "static-1.314",
      "dompurify": "static-1.8",
      "utility-belt": "static-1.2861",
      "bend-plugin-pulse": "static-1.461",
      "batch-promise": "static-1.1873",
      "chirp-fetch": "static-1.2223",
      "event-emitter": "static-1.1283",
      "fast-json-patch": "static-1.70",
      "hub-http-janus": "static-1.886",
      "quick-fetch": "static-1.4149",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1155",
      "web-vitals": "static-1.15",
      "bend-plugin-chirp-manifest": "static-1.406",
      "quartz-routing": "static-1.920",
      "usage-tracker-anonymous": "static-1.6059",
      "opentelemetry-fe-types": "static-1.107",
      "dispatcher": "static-1.143",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4883",
      "mobile-manifest-mixins": "static-1.580",
      "module-federation": "static-1.33",
      "opentelemetry-fe": "static-1.482",
      "quartz-auth": "static-1.1165",
      "quartz-test": "static-1.1165",
      "quartz-tracking": "static-1.869",
      "trellis-components": "static-1.2725",
      "usage-tracker-container": "static-1.7632",
      "bend-plugin-foundations-theming": "static-1.3288",
      "foundations-theming-base": "static-1.3790",
      "stylex": "static-1.41",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4986",
      "customer-data-ui-utilities": "static-1.10160",
      "FileManagerCore": "static-1.40057",
      "FileManagerLib": "static-1.40198",
      "hubspot-apollo-client": "static-1.5205",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.592",
      "timezone-utils": "static-2.5573",
      "ui-gdpr-components": "static-1.10625",
      "ts-schema": "static-1.4313",
      "ai-components-ui-library": "static-1.9770",
      "avatar-components": "static-1.2810",
      "content-assistance-lib": "static-1.8232",
      "crm-component-utils": "static-1.39887",
      "crm-display-components": "static-1.25637",
      "crm-fe-perf": "static-1.23227",
      "crm-links": "static-1.6658",
      "crm-message-bus": "static-1.43813",
      "crm-search-service-types": "static-1.1485",
      "crm-source-interpretation-lib": "static-1.5661",
      "customer-data-communicator": "static-1.46386",
      "customer-data-filters-ui": "static-1.40994",
      "customer-data-objects-ui-components": "static-1.13360",
      "customer-data-properties": "static-1.52662",
      "customer-data-rte": "static-1.33686",
      "draft-plugins": "static-2.22190",
      "file-manager-components": "static-1.24558",
      "trellis-theming": "static-1.1305",
      "framework-data-schema-resolvers": "static-1.7222",
      "frontend-preferences-client": "static-1.8250",
      "hubspot-prosemirror": "static-1.19026",
      "object-comments-thread-lib": "static-1.11374",
      "prosemirror-user-and-team-at-mentions": "static-1.1236",
      "reference-resolvers-lite": "static-1.8433",
      "ui-addon-upgrades": "static-9.18416",
      "universal-associations-select": "static-1.11408",
      "universal-record-utils-lib": "static-1.2031",
      "wootric-nps": "static-1.7220",
      "inbound-db-properties-service-client": "static-1.4066",
      "property-translator": "static-1.5724",
      "segments-query-core": "static-1.1753",
      "bender-build-tools": "static-1.3452",
      "stylex-utils": "static-1.146",
      "opentelemetry-web": "static-1.15",
      "hub-http-shared-msw-handlers": "static-1.10658",
      "hubspotter-http-shared-msw-handlers": "static-1.10656",
      "usage-tracker-session-replay": "static-1.5328",
      "base-ui": "static-1.22",
      "react-day-picker": "static-1.10",
      "tanstack-virtual": "static-1.38",
      "react-dnd-compat": "static-1.4945",
      "breeze-artifacts-sdk": "static-1.420",
      "copilot-toolkit": "static-1.11886",
      "audio-components": "static-1.6377",
      "ContentUtils": "static-1.69176",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29846",
      "FileManagerImages": "static-1.37709",
      "html-to-image": "static-1.61",
      "immerable": "static-1.4478",
      "react-colorpicker": "static-2.10545",
      "ui-universal-auth": "static-1.9446",
      "video-components": "static-1.14189",
      "video-data-lib": "static-1.35845",
      "video-embed": "static-1.36679",
      "hubspot-apollo-cache": "static-1.664",
      "chatspot-core": "static-1.23145",
      "superstore": "static-1.5086",
      "ui-addon-video-player": "static-1.9034",
      "ui-coaching-tips": "static-1.29351",
      "card-properties-lib": "static-1.45057",
      "commerce-subscription-lib": "static-1.37831",
      "crm-actions": "static-1.6678",
      "crm-cards-sdk": "static-1.44644",
      "customer-data-properties-shared-msw-handlers": "static-1.9985",
      "customer-data-property-utils": "static-1.8430",
      "customer-data-tracking": "static-1.7210",
      "hs-resources": "static-1.520",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12592",
      "location-customization-utils-lib": "static-1.10144",
      "restore-request-side-panel-lib": "static-1.1720",
      "calling-error-reporting": "static-1.31659",
      "calling-internal-common": "static-1.31652",
      "calling-usage-tracker": "static-1.6866",
      "crm_data": "static-4.92888",
      "customer-data-content": "static-1.27839",
      "draft-content-plugins": "static-1.28944",
      "draft-convert": "static-2.80",
      "draft-extend": "static-3.83",
      "draft-js": "static-5.85",
      "draft-signature-plugin": "static-1.24756",
      "EmailSignatureEditor": "static-1.25040",
      "hubspot-prosemirror-plugins": "static-1.19018",
      "integration-settings-components": "static-1.16256",
      "integrations-lib": "static-1.17095",
      "integrations-tracking-lib": "static-1.5937",
      "native-integrations-shared-strings": "static-1.8106",
      "nav-meta": "static-1.30514",
      "onboarding-scopes": "static-1.6782",
      "outreach-assistant-email-generation": "static-1.6857",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12352",
      "quotes-client-types": "static-1.38940",
      "reference-resolvers": "static-1.8509",
      "rich-text-lib": "static-1.20339",
      "sales-email-signature-service-client": "static-1.4175",
      "sequences-lib": "static-1.8563",
      "ui-addon-i18n": "static-1.11474",
      "ui-addon-iframeable": "static-1.9405",
      "ui-business-units-lib": "static-1.9419",
      "ui-shepherd-react": "static-3.10599",
      "user-context": "static-1.5451",
      "whatsapp-sending-lib": "static-1.6809",
      "customer-data-filters-ui-msw-helpers": "static-1.23429",
      "customer-data-reference-ui-components": "static-1.13507",
      "events-data-lib": "static-1.578",
      "FormUrlGenerator": "static-2.5055",
      "framework-builder-read-service-client": "static-1.4241",
      "multi-account-reference-resolvers": "static-1.1335",
      "onboarding-tours": "static-1.17157",
      "reporting-datasets-permissions-lib": "static-1.14510",
      "SharedI18nStrings": "static-1.183",
      "ui-addon-teams": "static-1.21936",
      "calling-global-api": "static-1.65695",
      "calling-lifecycle-internal": "static-1.67077",
      "calling-lifecycle-messages": "static-1.59371",
      "commerce-products-lib": "static-1.10589",
      "conditional-properties-service-client": "static-1.4036",
      "crm-index-visualization-core": "static-1.4576",
      "crm-pipelines-api-client-types": "static-1.4367",
      "external-options-client-types": "static-1.4360",
      "formula-editor": "static-1.14801",
      "google-libphonenumber": "static-1.45",
      "inbounddb-objects-service-types": "static-1.4448",
      "meetings-icalendar-utils-lib": "static-1.964",
      "multi-currency-client-types": "static-1.3928",
      "object-builder-ui-client": "static-1.49732",
      "pipeline-validation-client-types": "static-1.4202",
      "property-value-citations": "static-1.3276",
      "smart-data-capture-core": "static-1.179",
      "smart-property-lib": "static-1.8348",
      "tiered-pricing": "static-1.1996",
      "topics-actions-lib": "static-1.497",
      "trial-components-library": "static-1.14146",
      "ui-addon-form-validation": "static-1.11312",
      "zustand": "static-1.85",
      "breeze-engine-lib": "static-1.1806",
      "video-components-external": "static-1.12187",
      "fdsr-migration-layer": "static-1.341",
      "framework-data-schema-quick-fetch": "static-1.7127",
      "persist-promise": "static-1.4030",
      "content-media-capture": "static-1.5487",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26231",
      "knowledge-content-types": "static-1.8675",
      "payment-link-components": "static-1.24202",
      "ui-addon-emoji-picker": "static-1.10213",
      "call-summary": "static-1.40385",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10804",
      "laboratory-lib": "static-3.7482",
      "merchandise-lib": "static-1.278",
      "purchase-motions-components": "static-1.6399",
      "crm-object-search-query-utilities": "static-1.10232",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5778",
      "magpie-types": "static-1.5238",
      "simple-logging-lib": "static-1.3380",
      "foundations-components-legacy": "static-1.1553",
      "cms-field-types": "static-1.5142",
      "content-icons-ui": "static-1.2393",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1242",
      "social-insights-client-types": "static-1.22706",
      "outpost": "static-1.4482",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.6913",
      "customer-data-sidebar": "static-2.46779",
      "enrichment-lib": "static-1.471",
      "ui-addon-draggable-compat": "static-2.4592",
      "commerce-billing-lib": "static-1.20242",
      "commerce-shared-components-lib": "static-1.19274",
      "commerce-tools-ui-lib": "static-1.11088",
      "customer-data-associations": "static-1.7658",
      "tasks-actions-lib": "static-1.178",
      "reporting-data": "static-1.68890",
      "ui-addon-draggable": "static-3.5085",
      "crm-record-cards-service-types": "static-1.3796",
      "crm_universal": "static-1.22527",
      "SalesContentIndexUI": "static-3.9650",
      "content-embed-lib": "static-1.7666",
      "data-model-builder-lib": "static-1.13199",
      "remote-dom": "static-1.4",
      "remote-ui": "static-1.71",
      "ui-components-test-utils": "static-1.5954",
      "ui-extensions-remote-renderer": "static-1.17929",
      "universal-page-editor-lib": "static-1.3338",
      "integrations-error-boundary-lib": "static-1.14510",
      "redux-observable": "static-1.75",
      "ReduxMessenger": "static-2.10699",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.960",
      "ai-addon-copilot-preview": "static-1.8982",
      "data-token-picker": "static-1.16922",
      "sequences-client-types-lib": "static-1.8420",
      "foundations-components-test-utils": "static-1.6011",
      "navigation-messaging": "static-1.8204",
      "getting-started-shared-tasks": "static-1.19291",
      "getting-started-shared-tasks-store": "static-1.18409",
      "onboarding-tours-utils": "static-1.1224",
      "messaging-usage-based-billing-components-lib": "static-1.2054",
      "marketing-platform-lib": "static-1.7201",
      "whatsapp-management-lib": "static-1.9968",
      "growth-data-modal": "static-1.5930",
      "growth-onboarding-confetti": "static-1.3392",
      "growth-onboarding-next-action-utils": "static-1.2733",
      "navigation-components": "static-1.18877",
      "onboarding-tours-client": "static-1.5372",
      "ui-shepherd-tracker": "static-1.7980",
      "shared-worker-versioning": "static-1.11370",
      "voice-sms-access-library": "static-1.2111",
      "commerce-permissions": "static-1.1106",
      "products-iframe-lib": "static-1.8629",
      "products-ui-components-shared-msw-handlers": "static-1.11040",
      "crm-index-associations-lib": "static-1.6770",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10741",
      "sales-views-client-types": "static-1.4585",
      "bark-lib": "static-1.16841",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.102",
      "crm-properties-common-lib": "static-1.6218",
      "react-codemirror": "static-1.10971",
      "data-agent-kit": "static-1.681",
      "fsm": "static-1.4080",
      "policy-lib": "static-1.7134",
      "embedded-academy-lib": "static-1.15593",
      "hubs-service-types": "static-1.1590",
      "purchase-motions-api": "static-1.6402",
      "breeze-engine-chat-components": "static-1.784",
      "breeze-engine-core": "static-1.1084",
      "highlight.js": "static-1.86",
      "content-media-composition-data-lib": "static-1.13291",
      "content-media-compositions": "static-2.17298",
      "idb-keyval": "static-1.51",
      "media-bridge-lib": "static-1.19437",
      "fix-webm-duration": "static-1.30",
      "notification-sounds": "static-1.4753",
      "seat-types-lib": "static-1.779",
      "ui-addon-opt": "static-4.8694",
      "commerce-tours-lib": "static-1.6654",
      "growth-onboarding-reliability": "static-1.5409",
      "sales-checkout-service-client": "static-1.3858",
      "calling-cross-tab-library": "static-1.19629",
      "calling-lifecycle-usage-tracker": "static-1.9421",
      "reactive-lib": "static-1.1047",
      "card-payment-highlight-lib": "static-1.38036",
      "commerce-contract-lib": "static-1.13398",
      "invoices-highlight-card-lib": "static-1.55812",
      "orders-highlight-card-lib": "static-1.22238",
      "products-highlight-card-lib": "static-1.18872",
      "quotes-highlight-card-lib": "static-1.72850",
      "data-agent-utils": "static-1.533",
      "usage-based-billing-components-lib": "static-1.10333",
      "payments-enrollment-embed-lib": "static-1.23889",
      "stripe-embedded-components": "static-1.8027",
      "growth-onboarding-empty-states": "static-1.6313",
      "InboxConnectUtils": "static-4.15603",
      "payments-post-enroll-local-storage-lib": "static-1.5433",
      "qrcode-generator": "static-1.76",
      "reporting-client-types": "static-1.2706",
      "react-flip-move": "static-1.78",
      "FireAlarmUi": "static-1.4744",
      "sales-templates-service-types-lib": "static-1.4404",
      "ui-asset-management-lib": "static-1.11427",
      "association-settings-lib": "static-1.11062",
      "collaboration-sidebar": "static-1.58771",
      "conditional-property-settings-components": "static-1.288",
      "conditional-property-settings-modal": "static-1.13199",
      "data-model-commons-lib": "static-1.13427",
      "ExportDialog": "static-6.10708",
      "final-form": "static-1.78",
      "nudge-client-utils": "static-1.3179",
      "property-management-iframe": "static-1.14181",
      "property-usages-lib": "static-1.5834",
      "reactflow": "static-1.71",
      "simple-data-table": "static-1.3562",
      "used-in-list-lib": "static-1.7295",
      "visual-association": "static-1.6222",
      "highcharts": "static-8.111",
      "reporting-visualizations": "static-1.60965",
      "ui-extensibility-client-types": "static-1.4247",
      "adobe-sign-auth-lib": "static-1.513",
      "ads-unified-auth-lib": "static-1.1478",
      "generic-oauth-auth-lib": "static-1.88",
      "google-sheets-integration-lib": "static-1.1073",
      "microsoft-drive-auth-lib": "static-1.189",
      "surveymonkey-integration-lib": "static-1.530",
      "slack-ui-library": "static-1.10727",
      "ai-rendering-library": "static-1.11146",
      "ai-settings-ui-library": "static-1.8380",
      "breeze-engine-ui-devtools": "static-1.180",
      "copilot-plugins": "static-1.11858",
      "messaging-shared-utils-lib": "static-1.1503",
      "messaging-user-info-utils-lib": "static-1.1673",
      "content-whatsapp-service-types": "static-1.578",
      "short-messages-app-service-client": "static-1.4246",
      "ui-tool-access": "static-1.10484",
      "onboarding-data-sync-lib": "static-1.2545",
      "growth-onboarding-next-action-components": "static-1.2761",
      "user-context-client": "static-1.4834",
      "nest": "static-1.564",
      "calling-orchestration-schema": "static-1.36888",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16409",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4836",
      "storybook-react": "static-1.40",
      "academy-common-lib": "static-1.15053",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41107",
      "settings-ui-lib": "static-1.12852",
      "accounting-integrations-ui-components": "static-1.7569",
      "invoices-ui-lib": "static-1.55828",
      "commerce-products-api": "static-1.2722",
      "invoices-iframe-lib": "static-1.57886",
      "quotes-modal-lib": "static-1.103528",
      "quotes-ui-lib": "static-1.81571",
      "one-click-checkout": "static-1.450",
      "platform-infra-nav-components": "static-1.7912",
      "reporting-ui-components": "static-2.66160",
      "subscription-experience-data-types": "static-1.15264",
      "marketplace-ui-apps-core": "static-1.19315",
      "stripe-connect-js": "static-1.78",
      "ui-addon-react-router-dom": "static-1.9862",
      "hub-http-contrib": "static-1.3368",
      "ui-addon-sales-email": "static-1.5544",
      "nested-table": "static-1.565",
      "chatspot-widget-iframe": "static-1.23136",
      "collaboration-sidebar-common": "static-1.3568",
      "conditional-property-settings-data": "static-1.306",
      "nudge-custom-function-registry": "static-1.2936",
      "nudge-renderer-utils": "static-1.3255",
      "whisper-core-api": "static-1.7373",
      "property-management-common": "static-1.6469",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.779",
      "global-styles-ai-lib": "static-1.188",
      "marketplace-embed-ba": "static-1.665",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.42106",
      "reporting-snowflake": "static-1.57507",
      "upgrade-components-lib": "static-1.550",
      "ui-brand-identity-lib": "static-1.16582",
      "meetings-connect-utils-lib": "static-1.7939",
      "academy-service-client": "static-1.4021",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4733",
      "trellis-ecosystem": "static-1.7659",
      "commerce-tax-lib": "static-1.869",
      "price-books-api": "static-1.1773",
      "price-books-components": "static-1.1831",
      "property-description-translator": "static-1.4167",
      "ramp-editor": "static-1.930",
      "commerce-analytics-service-client": "static-1.3846",
      "totals-ui-components": "static-1.24333",
      "checkout-sdk": "static-3.24388",
      "payment-method-components": "static-1.7176",
      "touchless-buying-components": "static-1.6256",
      "upgrade-catalog-service-types": "static-1.3796",
      "reporting-plugins": "static-1.10786",
      "reporting-reports": "static-1.68567",
      "edison-service-client-types": "static-1.722",
      "developer-experience-shared-components": "static-1.10867",
      "marketplace-ui-client-types": "static-1.18190",
      "marketplace-ui-common": "static-1.20783",
      "ui-addon-integrations-directory-panel": "static-2.8356",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.478",
      "onboarding-journeys-lib": "static-1.981",
      "marketplace-embed": "static-1.22962",
      "marketplace-ui-install": "static-1.769",
      "marketplace-ui-tracking": "static-1.14953",
      "dashboard-lib": "static-1.82912",
      "share-with-third-party-component-lib": "static-1.9039",
      "ContentData": "static-1.69251",
      "line-items-api": "static-1.1127",
      "commerce-totals-service-types": "static-1.4052",
      "hub-http-rxjs": "static-1.851",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4320",
      "company-details-components": "static-1.6535",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.15926",
      "quote-checkout-service-types": "static-1.3782",
      "campaign-roi-lib": "static-1.10344",
      "campaigns-utils-lib": "static-1.3550",
      "ui-addon-calendars": "static-2.5669",
      "apps-service-types": "static-1.4067",
      "oauth-service-types": "static-1.4565",
      "ui-product-approvals-common": "static-1.1137",
      "connections-embed-lib": "static-1.1548",
      "fail-safe": "static-1.283",
      "ai-studio-lib": "static-1.12474",
      "integrations-reconnect-lib": "static-1.521",
      "ui-product-approvals": "static-1.29242",
      "redux-actions": "static-3.70",
      "advanced-menus-core": "static-1.15609",
      "advanced-menus-lib": "static-1.12482",
      "ui-memberships-settings-lib": "static-1.34887",
      "company-details-service-types": "static-1.4272",
      "pricing-pages-api": "static-1.15791",
      "bend-plugin-fail-safe": "static-1.234",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15608",
      "simple-menus-lib": "static-1.17125"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30692",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5052",
      "atom": "/atom/static-1.5414",
      "client-types": "/client-types/static-1.498",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9224",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16322",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13435",
      "conversations-message-history": "/conversations-message-history/static-1.13597",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10834",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24055",
      "data-fetching-client": "/data-fetching-client/static-1.9985",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5922",
      "hs-test-utils": "/hs-test-utils/static-1.8359",
      "hubspot-dlb": "/hubspot-dlb/static-2.1882",
      "HubStyleTokens": "/HubStyleTokens/static-2.11817",
      "I18n": "/I18n/static-7.1678",
      "immer": "/immer/static-1.101",
      "jasmine-immutable": "/jasmine-immutable/static-1.3350",
      "jasmine-runner": "/jasmine-runner/static-1.6780",
      "quartz": "/quartz/static-1.7490",
      "react-dlb": "/react-dlb/static-1.89",
      "react-select-plus": "/react-select-plus/static-1.113",
      "react-transition-group": "/react-transition-group/static-2.73",
      "redux-thunk": "/redux-thunk/static-2.80",
      "reselect": "/reselect/static-3.12",
      "sanitize": "/sanitize/static-1.4801",
      "StyleGuideUI": "/StyleGuideUI/static-3.505",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4862",
      "usage-tracker": "/usage-tracker/static-1.7642",
      "usage-tracker-core": "/usage-tracker-core/static-1.7492",
      "usage-tracker-public": "/usage-tracker-public/static-1.7453",
      "viral-links-lib": "/viral-links-lib/static-1.7406",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6480",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5141",
      "conversations-prop-types": "/conversations-prop-types/static-1.7789",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22792",
      "cssUtils": "/cssUtils/static-1.950",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.371",
      "foundations-components": "/foundations-components/static-1.8528",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6543",
      "interactive-cards": "/interactive-cards/static-1.395",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
      "immutable": "/immutable/static-2.83",
      "metrics-js": "/metrics-js/static-1.9867",
      "PatternValidationJS": "/PatternValidationJS/static-1.3222",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.958",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.196",
      "react-aria": "/react-aria/static-1.72",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "react-rhumb": "/react-rhumb/static-1.17050",
      "react-utils": "/react-utils/static-2.5575",
      "redux": "/redux/static-4.76",
      "rpc-client-utils": "/rpc-client-utils/static-1.4996",
      "redux-toolkit": "/redux-toolkit/static-1.78",
      "sanitize-text": "/sanitize-text/static-1.8487",
      "signup-constants": "/signup-constants/static-1.19669",
      "styled-components": "/styled-components/static-2.95",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6056",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6291",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1268",
      "quartz-core": "/quartz-core/static-1.6709",
      "foundations-assets": "/foundations-assets/static-1.5212",
      "foundations-theming": "/foundations-theming/static-1.4805",
      "UIComponents": "/UIComponents/static-3.8763",
      "conversations-async-data": "/conversations-async-data/static-2.8000",
      "customer-data-email": "/customer-data-email/static-1.18557",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "immutable-less": "/immutable-less/static-1.4978",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7576",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34119",
      "customer-data-objects": "/customer-data-objects/static-1.8024",
      "icons": "/icons/static-2.688",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.884",
      "ui-images": "/ui-images/static-2.1256",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.89",
      "HeadJS": "/HeadJS/static-2.800",
      "framer-motion": "/framer-motion/static-1.79",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3470",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.158",
      "i18n-data": "/i18n-data/static-1.230",
      "moment-timezone": "/moment-timezone/static-5.91",
      "jasmine": "/jasmine/static-4.4641",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8390",
      "HubStyle": "/HubStyle/static-2.12124",
      "quartz-i18n": "/quartz-i18n/static-1.1165",
      "sassPrefix": "/sassPrefix/static-1.218",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4797",
      "floating-ui": "/floating-ui/static-1.63",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2521",
      "hs-story-utils": "/hs-story-utils/static-1.9754",
      "react-create-root-preference": "/react-create-root-preference/static-1.75",
      "react-virtualized": "/react-virtualized/static-2.107",
      "tanstack-table": "/tanstack-table/static-1.61",
      "trellis-assets": "/trellis-assets/static-1.2706",
      "ui-fonts": "/ui-fonts/static-1.1079",
      "hs-locale-management": "/hs-locale-management/static-1.314",
      "dompurify": "/dompurify/static-1.8",
      "utility-belt": "/utility-belt/static-1.2861",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.461",
      "batch-promise": "/batch-promise/static-1.1873",
      "chirp-fetch": "/chirp-fetch/static-1.2223",
      "event-emitter": "/event-emitter/static-1.1283",
      "fast-json-patch": "/fast-json-patch/static-1.70",
      "hub-http-janus": "/hub-http-janus/static-1.886",
      "quick-fetch": "/quick-fetch/static-1.4149",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1155",
      "web-vitals": "/web-vitals/static-1.15",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.406",
      "quartz-routing": "/quartz-routing/static-1.920",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6059",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.107",
      "dispatcher": "/dispatcher/static-1.143",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4883",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.580",
      "module-federation": "/module-federation/static-1.33",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.482",
      "quartz-auth": "/quartz-auth/static-1.1165",
      "quartz-test": "/quartz-test/static-1.1165",
      "quartz-tracking": "/quartz-tracking/static-1.869",
      "trellis-components": "/trellis-components/static-1.2725",
      "usage-tracker-container": "/usage-tracker-container/static-1.7632",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3288",
      "foundations-theming-base": "/foundations-theming-base/static-1.3790",
      "stylex": "/stylex/static-1.41",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4986",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10160",
      "FileManagerCore": "/FileManagerCore/static-1.40057",
      "FileManagerLib": "/FileManagerLib/static-1.40198",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5205",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.592",
      "timezone-utils": "/timezone-utils/static-2.5573",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
      "ts-schema": "/ts-schema/static-1.4313",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9770",
      "avatar-components": "/avatar-components/static-1.2810",
      "content-assistance-lib": "/content-assistance-lib/static-1.8232",
      "crm-component-utils": "/crm-component-utils/static-1.39887",
      "crm-display-components": "/crm-display-components/static-1.25637",
      "crm-fe-perf": "/crm-fe-perf/static-1.23227",
      "crm-links": "/crm-links/static-1.6658",
      "crm-message-bus": "/crm-message-bus/static-1.43813",
      "crm-search-service-types": "/crm-search-service-types/static-1.1485",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5661",
      "customer-data-communicator": "/customer-data-communicator/static-1.46386",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40994",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13360",
      "customer-data-properties": "/customer-data-properties/static-1.52662",
      "customer-data-rte": "/customer-data-rte/static-1.33686",
      "draft-plugins": "/draft-plugins/static-2.22190",
      "file-manager-components": "/file-manager-components/static-1.24558",
      "trellis-theming": "/trellis-theming/static-1.1305",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7222",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8250",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19026",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11374",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1236",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8433",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18416",
      "universal-associations-select": "/universal-associations-select/static-1.11408",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2031",
      "wootric-nps": "/wootric-nps/static-1.7220",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
      "property-translator": "/property-translator/static-1.5724",
      "segments-query-core": "/segments-query-core/static-1.1753",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "stylex-utils": "/stylex-utils/static-1.146",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10658",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10656",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5328",
      "base-ui": "/base-ui/static-1.22",
      "react-day-picker": "/react-day-picker/static-1.10",
      "tanstack-virtual": "/tanstack-virtual/static-1.38",
      "react-dnd-compat": "/react-dnd-compat/static-1.4945",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.420",
      "copilot-toolkit": "/copilot-toolkit/static-1.11886",
      "audio-components": "/audio-components/static-1.6377",
      "ContentUtils": "/ContentUtils/static-1.69176",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29846",
      "FileManagerImages": "/FileManagerImages/static-1.37709",
      "html-to-image": "/html-to-image/static-1.61",
      "immerable": "/immerable/static-1.4478",
      "react-colorpicker": "/react-colorpicker/static-2.10545",
      "ui-universal-auth": "/ui-universal-auth/static-1.9446",
      "video-components": "/video-components/static-1.14189",
      "video-data-lib": "/video-data-lib/static-1.35845",
      "video-embed": "/video-embed/static-1.36679",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.664",
      "chatspot-core": "/chatspot-core/static-1.23145",
      "superstore": "/superstore/static-1.5086",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9034",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29351",
      "card-properties-lib": "/card-properties-lib/static-1.45057",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37831",
      "crm-actions": "/crm-actions/static-1.6678",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44644",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9985",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8430",
      "customer-data-tracking": "/customer-data-tracking/static-1.7210",
      "hs-resources": "/hs-resources/static-1.520",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12592",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10144",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1720",
      "calling-error-reporting": "/calling-error-reporting/static-1.31659",
      "calling-internal-common": "/calling-internal-common/static-1.31652",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6866",
      "crm_data": "/crm_data/static-4.92888",
      "customer-data-content": "/customer-data-content/static-1.27839",
      "draft-content-plugins": "/draft-content-plugins/static-1.28944",
      "draft-convert": "/draft-convert/static-2.80",
      "draft-extend": "/draft-extend/static-3.83",
      "draft-js": "/draft-js/static-5.85",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24756",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25040",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19018",
      "integration-settings-components": "/integration-settings-components/static-1.16256",
      "integrations-lib": "/integrations-lib/static-1.17095",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5937",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8106",
      "nav-meta": "/nav-meta/static-1.30514",
      "onboarding-scopes": "/onboarding-scopes/static-1.6782",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6857",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12352",
      "quotes-client-types": "/quotes-client-types/static-1.38940",
      "reference-resolvers": "/reference-resolvers/static-1.8509",
      "rich-text-lib": "/rich-text-lib/static-1.20339",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4175",
      "sequences-lib": "/sequences-lib/static-1.8563",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11474",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9405",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9419",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10599",
      "user-context": "/user-context/static-1.5451",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6809",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23429",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13507",
      "events-data-lib": "/events-data-lib/static-1.578",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5055",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4241",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1335",
      "onboarding-tours": "/onboarding-tours/static-1.17157",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14510",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
      "ui-addon-teams": "/ui-addon-teams/static-1.21936",
      "calling-global-api": "/calling-global-api/static-1.65695",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67077",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59371",
      "commerce-products-lib": "/commerce-products-lib/static-1.10589",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4036",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4576",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4367",
      "external-options-client-types": "/external-options-client-types/static-1.4360",
      "formula-editor": "/formula-editor/static-1.14801",
      "google-libphonenumber": "/google-libphonenumber/static-1.45",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4448",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.964",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3928",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49732",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4202",
      "property-value-citations": "/property-value-citations/static-1.3276",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.179",
      "smart-property-lib": "/smart-property-lib/static-1.8348",
      "tiered-pricing": "/tiered-pricing/static-1.1996",
      "topics-actions-lib": "/topics-actions-lib/static-1.497",
      "trial-components-library": "/trial-components-library/static-1.14146",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11312",
      "zustand": "/zustand/static-1.85",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1806",
      "video-components-external": "/video-components-external/static-1.12187",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.341",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7127",
      "persist-promise": "/persist-promise/static-1.4030",
      "content-media-capture": "/content-media-capture/static-1.5487",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26231",
      "knowledge-content-types": "/knowledge-content-types/static-1.8675",
      "payment-link-components": "/payment-link-components/static-1.24202",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10213",
      "call-summary": "/call-summary/static-1.40385",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10804",
      "laboratory-lib": "/laboratory-lib/static-3.7482",
      "merchandise-lib": "/merchandise-lib/static-1.278",
      "purchase-motions-components": "/purchase-motions-components/static-1.6399",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10232",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5778",
      "magpie-types": "/magpie-types/static-1.5238",
      "simple-logging-lib": "/simple-logging-lib/static-1.3380",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1553",
      "cms-field-types": "/cms-field-types/static-1.5142",
      "content-icons-ui": "/content-icons-ui/static-1.2393",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1242",
      "social-insights-client-types": "/social-insights-client-types/static-1.22706",
      "outpost": "/outpost/static-1.4482",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6913",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46779",
      "enrichment-lib": "/enrichment-lib/static-1.471",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4592",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20242",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19274",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11088",
      "customer-data-associations": "/customer-data-associations/static-1.7658",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.178",
      "reporting-data": "/reporting-data/static-1.68890",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5085",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
      "crm_universal": "/crm_universal/static-1.22527",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9650",
      "content-embed-lib": "/content-embed-lib/static-1.7666",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13199",
      "remote-dom": "/remote-dom/static-1.4",
      "remote-ui": "/remote-ui/static-1.71",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5954",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17929",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3338",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14510",
      "redux-observable": "/redux-observable/static-1.75",
      "ReduxMessenger": "/ReduxMessenger/static-2.10699",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.960",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8982",
      "data-token-picker": "/data-token-picker/static-1.16922",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8420",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6011",
      "navigation-messaging": "/navigation-messaging/static-1.8204",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19291",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18409",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1224",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2054",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7201",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9968",
      "growth-data-modal": "/growth-data-modal/static-1.5930",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3392",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2733",
      "navigation-components": "/navigation-components/static-1.18877",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5372",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7980",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11370",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2111",
      "commerce-permissions": "/commerce-permissions/static-1.1106",
      "products-iframe-lib": "/products-iframe-lib/static-1.8629",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11040",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6770",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10741",
      "sales-views-client-types": "/sales-views-client-types/static-1.4585",
      "bark-lib": "/bark-lib/static-1.16841",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.102",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6218",
      "react-codemirror": "/react-codemirror/static-1.10971",
      "data-agent-kit": "/data-agent-kit/static-1.681",
      "fsm": "/fsm/static-1.4080",
      "policy-lib": "/policy-lib/static-1.7134",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15593",
      "hubs-service-types": "/hubs-service-types/static-1.1590",
      "purchase-motions-api": "/purchase-motions-api/static-1.6402",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.784",
      "breeze-engine-core": "/breeze-engine-core/static-1.1084",
      "highlight.js": "/highlight.js/static-1.86",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13291",
      "content-media-compositions": "/content-media-compositions/static-2.17298",
      "idb-keyval": "/idb-keyval/static-1.51",
      "media-bridge-lib": "/media-bridge-lib/static-1.19437",
      "fix-webm-duration": "/fix-webm-duration/static-1.30",
      "notification-sounds": "/notification-sounds/static-1.4753",
      "seat-types-lib": "/seat-types-lib/static-1.779",
      "ui-addon-opt": "/ui-addon-opt/static-4.8694",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6654",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5409",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3858",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19629",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9421",
      "reactive-lib": "/reactive-lib/static-1.1047",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38036",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13398",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55812",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22238",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18872",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
      "data-agent-utils": "/data-agent-utils/static-1.533",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10333",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23889",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8027",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6313",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15603",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5433",
      "qrcode-generator": "/qrcode-generator/static-1.76",
      "reporting-client-types": "/reporting-client-types/static-1.2706",
      "react-flip-move": "/react-flip-move/static-1.78",
      "FireAlarmUi": "/FireAlarmUi/static-1.4744",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4404",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11427",
      "association-settings-lib": "/association-settings-lib/static-1.11062",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58771",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.288",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13199",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13427",
      "ExportDialog": "/ExportDialog/static-6.10708",
      "final-form": "/final-form/static-1.78",
      "nudge-client-utils": "/nudge-client-utils/static-1.3179",
      "property-management-iframe": "/property-management-iframe/static-1.14181",
      "property-usages-lib": "/property-usages-lib/static-1.5834",
      "reactflow": "/reactflow/static-1.71",
      "simple-data-table": "/simple-data-table/static-1.3562",
      "used-in-list-lib": "/used-in-list-lib/static-1.7295",
      "visual-association": "/visual-association/static-1.6222",
      "highcharts": "/highcharts/static-8.111",
      "reporting-visualizations": "/reporting-visualizations/static-1.60965",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4247",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.513",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1478",
      "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.88",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1073",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.189",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.530",
      "slack-ui-library": "/slack-ui-library/static-1.10727",
      "ai-rendering-library": "/ai-rendering-library/static-1.11146",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8380",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.180",
      "copilot-plugins": "/copilot-plugins/static-1.11858",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1503",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1673",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4246",
      "ui-tool-access": "/ui-tool-access/static-1.10484",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2545",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2761",
      "user-context-client": "/user-context-client/static-1.4834",
      "nest": "/nest/static-1.564",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36888",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16409",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4836",
      "storybook-react": "/storybook-react/static-1.40",
      "academy-common-lib": "/academy-common-lib/static-1.15053",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41107",
      "settings-ui-lib": "/settings-ui-lib/static-1.12852",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7569",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55828",
      "commerce-products-api": "/commerce-products-api/static-1.2722",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57886",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
      "one-click-checkout": "/one-click-checkout/static-1.450",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7912",
      "reporting-ui-components": "/reporting-ui-components/static-2.66160",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15264",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19315",
      "stripe-connect-js": "/stripe-connect-js/static-1.78",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9862",
      "hub-http-contrib": "/hub-http-contrib/static-1.3368",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5544",
      "nested-table": "/nested-table/static-1.565",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23136",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3568",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.306",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2936",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3255",
      "whisper-core-api": "/whisper-core-api/static-1.7373",
      "property-management-common": "/property-management-common/static-1.6469",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.779",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.188",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.665",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.42106",
      "reporting-snowflake": "/reporting-snowflake/static-1.57507",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.550",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16582",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7939",
      "academy-service-client": "/academy-service-client/static-1.4021",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4733",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7659",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.869",
      "price-books-api": "/price-books-api/static-1.1773",
      "price-books-components": "/price-books-components/static-1.1831",
      "property-description-translator": "/property-description-translator/static-1.4167",
      "ramp-editor": "/ramp-editor/static-1.930",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3846",
      "totals-ui-components": "/totals-ui-components/static-1.24333",
      "checkout-sdk": "/checkout-sdk/static-3.24388",
      "payment-method-components": "/payment-method-components/static-1.7176",
      "touchless-buying-components": "/touchless-buying-components/static-1.6256",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
      "reporting-plugins": "/reporting-plugins/static-1.10786",
      "reporting-reports": "/reporting-reports/static-1.68567",
      "edison-service-client-types": "/edison-service-client-types/static-1.722",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10867",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18190",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20783",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8356",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.478",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.981",
      "marketplace-embed": "/marketplace-embed/static-1.22962",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.769",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14953",
      "dashboard-lib": "/dashboard-lib/static-1.82912",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9039",
      "ContentData": "/ContentData/static-1.69251",
      "line-items-api": "/line-items-api/static-1.1127",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4052",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.851",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4320",
      "company-details-components": "/company-details-components/static-1.6535",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15926",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3782",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10344",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3550",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5669",
      "apps-service-types": "/apps-service-types/static-1.4067",
      "oauth-service-types": "/oauth-service-types/static-1.4565",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1137",
      "connections-embed-lib": "/connections-embed-lib/static-1.1548",
      "fail-safe": "/fail-safe/static-1.283",
      "ai-studio-lib": "/ai-studio-lib/static-1.12474",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.521",
      "ui-product-approvals": "/ui-product-approvals/static-1.29242",
      "redux-actions": "/redux-actions/static-3.70",
      "advanced-menus-core": "/advanced-menus-core/static-1.15609",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12482",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34887",
      "company-details-service-types": "/company-details-service-types/static-1.4272",
      "pricing-pages-api": "/pricing-pages-api/static-1.15791",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.234",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15608",
      "simple-menus-lib": "/simple-menus-lib/static-1.17125"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30692",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};